/*
 * product-sample-player.js — progressive enhancement for the product-page
 * "Program Sessions" list (theme/snippets/product-track-list.liquid).
 *
 *  1. Fills each row's duration from the custom.track_durations JSON string
 *     (embedded as data-track-durations — a single_line_text_field, so it is
 *     NOT Liquid-iterable and must be parsed here).
 *  2. Wires the ▶ Sample buttons to the public Worker /sample endpoint, which
 *     streams a bounded ~5-min preview window. Only one sample plays at a time.
 *
 * Vanilla JS, no dependencies. Fires NO analytics/tracking (playback is
 * user-initiated audio, not tracking) — see rules/cookie_consent_convention.md.
 * The ONLY audio URL used is the Worker /sample endpoint; no S3/presigned URL
 * is ever constructed client-side, and no client-controlled offset is sent.
 */
(function () {
  'use strict';

  var WORKER_BASE = 'https://downloads-api.nightingale.com';
  var SAMPLE_FALLBACK_DUR = 300; // used only when a row has no known duration

  function fmtDur(totalSeconds) {
    var s = Math.max(0, Math.round(Number(totalSeconds) || 0));
    var h = Math.floor(s / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    return h > 0 ? h + ':' + pad(m) + ':' + pad(sec) : m + ':' + pad(sec);
  }

  function parseDurations(raw) {
    var map = {};
    if (!raw) return map;
    try {
      var arr = JSON.parse(raw);
      if (Array.isArray(arr)) {
        arr.forEach(function (d) {
          if (d && d.name != null) map[d.name] = Number(d.seconds) || 0;
        });
      }
    } catch (e) { /* durations are optional — leave slots blank */ }
    return map;
  }

  function initList(container) {
    var s3idn = container.getAttribute('data-s3idn') || '';
    var durMap = parseDurations(container.getAttribute('data-track-durations'));

    // Fill duration slots.
    var items = container.querySelectorAll('.product-track-list__item');
    Array.prototype.forEach.call(items, function (li) {
      var file = li.getAttribute('data-track-file');
      var secs = durMap[file] || 0;
      if (secs > 0) {
        var slot = li.querySelector('[data-track-dur-slot]');
        if (slot) slot.textContent = fmtDur(secs);
      }
    });

    // One shared audio element → at most one sample plays at a time.
    var audio = new Audio();
    audio.preload = 'none';
    var currentBtn = null;

    function setLabel(btn, text) {
      var label = btn && btn.querySelector('.product-track-list__sample-label');
      if (label) label.textContent = text;
    }
    function setIcon(btn, text) {
      var icon = btn && btn.querySelector('.product-track-list__sample-icon');
      if (icon) icon.textContent = text;
    }
    function resetBtn(btn) {
      if (!btn) return;
      btn.classList.remove('is-loading', 'is-playing', 'is-error');
      setLabel(btn, 'Sample');
      setIcon(btn, '▶'); // ▶
      btn.disabled = false;
    }
    function stopCurrent() {
      if (currentBtn) { resetBtn(currentBtn); currentBtn = null; }
      try { audio.pause(); } catch (e) { /* ignore */ }
    }
    function errorBtn(btn) {
      if (!btn) return;
      btn.classList.remove('is-loading', 'is-playing');
      btn.classList.add('is-error');
      setLabel(btn, 'Unavailable');
      setIcon(btn, '▶');
      btn.disabled = false;
    }

    audio.addEventListener('playing', function () {
      if (!currentBtn) return;
      currentBtn.classList.remove('is-loading');
      currentBtn.classList.add('is-playing');
      setLabel(currentBtn, 'Playing');
      setIcon(currentBtn, '■'); // ■ (stop)
    });
    audio.addEventListener('ended', function () { stopCurrent(); });
    audio.addEventListener('error', function () {
      var b = currentBtn;
      currentBtn = null;
      errorBtn(b);
    });

    var buttons = container.querySelectorAll('[data-sample-btn]');
    Array.prototype.forEach.call(buttons, function (btn) {
      var file = btn.getAttribute('data-track-file');
      var secs = durMap[file] || 0;
      btn.addEventListener('click', function () {
        // Clicking the currently-playing row toggles it off.
        if (currentBtn === btn && !audio.paused) {
          stopCurrent();
          return;
        }
        stopCurrent();
        if (!s3idn || !file) { errorBtn(btn); return; }

        currentBtn = btn;
        btn.classList.add('is-loading');
        setLabel(btn, 'Loading');

        var url = WORKER_BASE + '/sample'
          + '?idn=' + encodeURIComponent(s3idn)
          + '&file=' + encodeURIComponent(file)
          + '&dur=' + encodeURIComponent(secs || SAMPLE_FALLBACK_DUR);
        audio.src = url;

        // iOS Safari: play() must be called synchronously within the click.
        var p = audio.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            if (currentBtn === btn) { currentBtn = null; errorBtn(btn); }
          });
        }
      });
    });
  }

  function init() {
    var lists = document.querySelectorAll('[data-product-track-list]');
    Array.prototype.forEach.call(lists, function (el) { initList(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
